import { Image, Rate } from "antd";
import dayjs from "dayjs";
import React from "react";

import notShowingImage from "../../../../assets/images/png/empty-image.png";

export default function ReviewCard({ data }) {
  return (
    <div className="review-card-container">
      {/* <Rate disabled={true} allowHalf value={data.rate} /> */}
      {/* <h3 style={{ marginTop: 20 }}></h3> */}
      <div style={{ marginTop: 10 }}>{data.comment}</div>
      <div style={{ display: "flex", alignItems: "cneter", gap: 10, marginTop: 20 }}>
        <Image src={data.is_show_profile_image && data?.file_uploads[0] ? data?.file_uploads[0]?.image_url : notShowingImage} style={{ width: 30, height: 30, borderRadius: "50%" }} preview={false} />
        <div>
          <div style={{ color: "#757575" }}>{data?.golfer_name ?? "ไม่ระบุตัวตน"}</div>
          <div style={{ color: "#B3B3B3" }}>{data?.created_at ? dayjs(data?.created_at).format("DD-MM-YYYY") : "-"}</div>
        </div>
      </div>
    </div>
  );
}
